module.exports = __webpack_public_path__ + "img/4.c9b99d1c.png";